// Thin os-core wrapper around the @os/knowledgebase web page, mirroring
// CalendarWorkspacePage. Routed from App.tsx at /workspace/knowledge.
import KnowledgeIndexPage from '@os/knowledgebase/web/pages/KnowledgeIndexPage'

export default function KnowledgeWorkspacePage() {
  return <KnowledgeIndexPage />
}
